/*
 * Description: 处理请求头，apitoken、针对一般的post和文件上传，设置不同的headers，根据环境获取不同的baseUrl
 * Author: zhanghj
 * Date: 2022-04-12 12:02:39
 * LastEditors: zhanghj
 * LastEditTime: 2022-04-12 12:06:13
 */
const commmonHeader = {
  Accept: 'application/json',
};

/* 常规的 */
export const featchApiHeader = {
  ...commmonHeader,
  'Content-Type': 'application/x-www-form-urlencoded',
};

/* 文件的 */
export const formApiHeader = {
  ...commmonHeader,
  'Content-Type': 'multipart/form-data',
};

export const baseApiUrl = process.env.VUE_APP_SERVER_URL;



// WEBPACK FOOTER //
// ./src/utils/requestUtil.js